import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  phone: "",
  eventDate: "",
  message: "",
};

export const Contact = (props) => {
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [formStatus, setFormStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));

    // Clear error when input changes
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormStatus("");
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.name.trim()) formErrors.name = "Name is required.";
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) {
      formErrors.email = "A valid email is required.";
    }
    if (!formData.phone.trim() || formData.phone.length < 10) {
      formErrors.phone = "Phone number must be at least 10 digits.";
    }
    if (!formData.eventDate.trim()) formErrors.eventDate = "Event date is required.";
    return formErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length === 0) {
      emailjs
        .sendForm("service_809lq56", "template_nkrwgix", e.target, "HaGfqL8JFc4aOBqM8")
        .then(
          (result) => {
            console.log(result.text);
            setFormStatus("Success! Your booking request has been sent.");
            clearState();
          },
          (error) => {
            console.log(error.text);
            setFormStatus("An error occurred. Please try again later.");
          }
        );
    } else {
      setErrors(formErrors);
    }
  };

  const clearState = () => setFormData({ ...initialState });

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Enquire now</h2>
                <p>
                  Please fill out the form below to require about booking for your event, and we will get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && <p className="help-block text-danger">{errors.name}</p>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <p className="help-block text-danger">{errors.email}</p>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                      {errors.phone && <p className="help-block text-danger">{errors.phone}</p>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="date"
                        id="eventDate"
                        name="eventDate"
                        className="form-control"
                        value={formData.eventDate}
                        onChange={handleChange}
                      />
                      {errors.eventDate && <p className="help-block text-danger">{errors.eventDate}</p>}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Additional Details (if any)"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-custom btn-lg">
                  Contact Us!
                </button>
                {formStatus && <p className="form-status">{formStatus}</p>}
              </form>
            </div>
          </div>

          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone1 : "loading"}- JEFF <br />
                {props.data ? props.data.phone2 : "loading"}- CHRIS
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>

        
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Chinaza Ogwudiegwu Design by{" "}
            <a href="http://www.nazacodes.com" rel="nofollow">
              Nazacodes
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
